import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/rootReducer'
import { MemberState } from '../../../store/member/memberTypings'
import './walletPoints.sass'

const WalletPoints = () => {
    const [t] = useTranslation()

    const { user } = useSelector<RootState, MemberState>((state) => state.member)
    if (user && typeof user.counters.wallet_amount === 'number')
        return (
            <div className={'amountOfPoints'}>
                <img src={require('./../../../assets/ic-mypoints.svg')} alt="My points" />
                <p>{user.counters.wallet_amount}</p>
                <p>{t('points')}</p>
            </div>
        )
    return <></>
}

export default WalletPoints
